import { NgModule } from '@angular/core';

import { CollapseAnimationDirective } from './animations.directive';
export class AnimationsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [CollapseAnimationDirective],
    declarations: [CollapseAnimationDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AnimationsModule_tsickle_Closure_declarations() {
/** @type {?} */
AnimationsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AnimationsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
